var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4771_3042)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.874 8.01446C18.591 9.35035 19 10.8774 19 12.4993V12.9993H18V12.4993C18 11.1584 17.6791 9.89432 17.124 8.76451L17.874 8.01446ZM13.2351 4.87626C12.106 4.3203 10.8411 4.00025 9.50011 4.00025C4.81318 4.00025 1.00013 7.81308 1.00013 12.4998V12.9999H0L0 12.4998C0 7.253 4.25312 3 9.50028 3C11.1233 3 12.6493 3.40796 13.9853 4.12595L13.2353 4.87592L13.2351 4.87626ZM16.1466 5.14646C16.3416 4.95143 16.6585 4.95143 16.8536 5.14646C17.0486 5.34148 17.0486 5.65837 16.8536 5.8534L9.8536 12.853C9.75566 12.951 9.62759 13 9.50052 13C9.37245 13 9.24455 12.951 9.14644 12.853C8.95141 12.658 8.95141 12.3411 9.14644 12.1461L16.1466 5.14646Z",
    fill: "#30B3D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4771_3042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2df4e99dd12d2d828f78bb6ed5c840e9.svg";
export { ForwardRef as ReactComponent };